import { render, staticRenderFns } from "./escolas.vue?vue&type=template&id=a86cdc96&scoped=true&"
import script from "./escolas.vue?vue&type=script&lang=js&"
export * from "./escolas.vue?vue&type=script&lang=js&"
import style0 from "./escolas.vue?vue&type=style&index=0&id=a86cdc96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a86cdc96",
  null
  
)

export default component.exports